import { useRef, useState } from "react";
import { FileSpreadsheet, UploadCloud, X } from "lucide-react";
import { cn } from "@/lib/utils";

export default function Dropzone({ files, setFiles }) {
  const ref = useRef(null);
  const [over, setOver] = useState(false);
  const add = (list) => {
    const incoming = Array.from(list || []).filter((f) => /\.(xlsx|csv)$/i.test(f.name));
    setFiles([...files, ...incoming]);
  };
  return (
    <div>
      <div onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
        onDrop={(e) => { e.preventDefault(); setOver(false); add(e.dataTransfer.files); }}
        className={cn("rounded-xl border-2 border-dashed p-6 transition-colors md:p-8", over ? "border-brand bg-brand-soft" : "border-zinc-400 bg-white")}
        data-testid="import-dropzone">
        <div className="flex flex-col items-center text-center">
          <UploadCloud className="h-10 w-10 text-ink" strokeWidth={1.5} />
          <div className="mt-2 font-display text-lg font-bold">Tarik & lepas file .xlsx di sini</div>
          <div className="text-sm text-zinc-500">Bisa banyak file sekaligus</div>
          <button type="button" onClick={() => ref.current?.click()} className="press mt-4 rounded-md bg-ink px-5 py-3 text-sm font-semibold text-white" data-testid="import-browse-btn">Pilih File</button>
          <input ref={ref} type="file" multiple accept=".xlsx,.csv" className="hidden" data-testid="import-file-input" onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
        </div>
        <div className="mt-6 grid gap-4 text-left text-[13px] leading-relaxed text-zinc-700 md:grid-cols-2" data-testid="import-instructions">
          <div className="rounded-lg border border-orange-200 bg-orange-50/60 p-4">
            <div className="mb-1 font-bold text-orange-900">Shopee</div>
            Export dari Seller Centre tab <b>"Dalam Pengiriman"</b> dan <b>"Selesai"</b>, rentang tanggal pesanan <b>3 hari sebelum</b> tanggal rekap s/d tanggal rekap
            (contoh rekap 8 Okt → export 5–8 Okt atau 6–9 Okt). Sistem hanya mengambil baris dengan <b>Waktu Pengiriman Diatur = tanggal rekap</b>.
            Pesanan pre-order / dibuat hari sebelumnya tetap terhitung selama waktu pengirimannya di tanggal rekap.
          </div>
          <div className="rounded-lg border border-emerald-200 bg-emerald-50/60 p-4">
            <div className="mb-1 font-bold text-emerald-900">Tokopedia / TikTok Shop</div>
            Export dari tab <b>1) Menunggu Pengambilan, 2) Dikirim, 3) Selesai</b>, filter waktu pengiriman di tanggal yang ingin direkap.
            Sistem hanya mengambil baris dengan <b>RTS Time = tanggal rekap</b>. Pesanan COD (Paid Time kosong) tetap dihitung.
          </div>
          <div className="text-xs text-zinc-500 md:col-span-2">File yang sama boleh ter-upload dua kali — sistem otomatis anti-dobel.</div>
        </div>
      </div>
      {files.length > 0 && (
        <ul className="mt-4 space-y-2" data-testid="import-file-list">
          {files.map((f, i) => (
            <li key={`${f.name}-${i}`} className="flex items-center gap-3 rounded-md border border-zinc-200 bg-white px-3 py-2.5 text-sm">
              <FileSpreadsheet className="h-4 w-4 text-emerald-700" /><span className="flex-1 truncate">{f.name}</span>
              <span className="num text-xs text-zinc-400">{(f.size / 1024).toFixed(0)} KB</span>
              <button onClick={() => setFiles(files.filter((_, j) => j !== i))} className="text-zinc-400 hover:text-brand" data-testid={`import-remove-file-${i}`}><X className="h-4 w-4" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
